// extracted by mini-css-extract-plugin
export default {"tournamentImage":"imagesDropdown_tournamentImage__iUN7Y","active":"imagesDropdown_active__VXhwA","selectItems":"imagesDropdown_selectItems__080jV"};